module.exports = __webpack_public_path__ + "static/media/stats.a0e060da.svg";